"use client";

import { observer } from "mobx-react";
import { useStores } from "@soprisapps/components/stores/useStores";
import ProfileCompletionModal from "@soprisapps/components/components/modals/ProfileCompletionModal";

const ProfileCompletionCheck = observer(() => {
  const { userStore } = useStores();

  if (!userStore.isMagicLinkUser || userStore.hasCompleteName) {
    return null;
  }

  return <ProfileCompletionModal active={true} />;
});

export default ProfileCompletionCheck;
